export default __webpack_public_path__ + "images/LED.4d9c716.png";